import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function OopbuySpreadsheet() {
  return <ArticleLayout content={allArticles[7]} />;
}